import ShareAuth from '@sagano/share/vendors/firebase';
import { auth } from '@sagano/station/stores';

const stationAuth = new ShareAuth(auth);

export const storage = stationAuth.storage;
export default stationAuth;
